import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ServicerTransferQuerySearchCriteria, ServicerTransferSummaryList, TransactionWrapper } from '../../../model/models';
import { UtilityService } from '../../../services/utility-service';
import { ApiService } from '../../../services/api.service';
import { ErrorService } from '../../../shared/error-page/service/error-service';
import { Router } from '@angular/router';
import { Constants } from '../../../constants/ebtq-constants';
import {Title} from '@angular/platform-browser';
import {SelectItem} from '@fm-ui-adk/components-3';

@Component({
  standalone: false,
  selector: 'app-query-servicer-transfers',
  templateUrl: './query-servicer-transfers.component.html',
  styleUrls: ['./query-servicer-transfers.component.scss']
})
export class QueryServicerTransfersComponent implements OnInit {

  constructor(apiService: ApiService, router: Router, private errorService: ErrorService, private titleService: Title, private cdr: ChangeDetectorRef) {
    this.utilService = new UtilityService();
    this.service = apiService;
    this.router = router;

    this.queryServicerTransfersForm = new UntypedFormGroup({
      servicerNumberFromUI: new UntypedFormControl(''),
      servicerNumberTo: new UntypedFormControl(''),
      effectiveDateFrom: new UntypedFormControl(''),
      effectiveDateTo: new UntypedFormControl(''),
      creationDateFrom: new UntypedFormControl(''),
      creationDateTo: new UntypedFormControl(''),
      transactionStatusList: new UntypedFormControl(''),
      sortBy: new UntypedFormControl('')
    });

    this.transactionStatusList = [];
    this.transactionStatusList.push({ label: 'Pending', value: '1' });
    this.transactionStatusList.push({ label: 'Approved', value: '2' });
    this.transactionStatusList.push({ label: 'Applied', value: '3' });
    this.transactionStatusList.push({ label: 'Deleted', value: '5' });

    this.sortBy = [];
    this.sortBy.push({ label: 'Servicer Number Transfer From', value: '1' });
    this.sortBy.push({ label: 'Effective Date', value: '2' });
    this.sortBy.push({ label: 'Receipt Date', value: '3' });
    this.sortBy.push({ label: 'Status', value: '4' });

  }
  warningMessage: string;
  errorMessage: string[] = [];
  containsError = false;
  errorMsg: string;

  utilService: UtilityService;
  service: ApiService;
  router: Router;

  effectiveDateTo: Date;
  effectiveDateFrom: Date;
  creationDateFrom: Date;
  creationDateTo: Date;
  transactionStatusList: SelectItem[];
  sortBy: any[];

  queryServicerTransfersForm: UntypedFormGroup;

  title = 'Submit Servicer Transfer Query';
  serNumber: any[];
  isExternal: boolean;

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.errorMessage = [];
    this.warningMessage = '';
    this.queryServicerTransfersForm.reset();

    this.serNumber = [];

    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.isExternal = (this.isExternal == null) ? false : this.isExternal;
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');

    if (this.isExternal) {
      if (sessionStorage.getItem('authServrList') != null) {
        const authServrList = Array.from(JSON.parse(sessionStorage.getItem('authServrList')));
        this.serNumber.push({label: 'ALL', value: 'ALL'});
        for (let i = 0; i < authServrList.length; i++) {
          this.serNumber.push(authServrList[i]);
        }
        this.queryServicerTransfersForm.controls.servicerNumberFromUI.setValue(this.serNumber[0].value);
      }
    }
  }

  public servicerTransferList(): void {
    this.warningMessage = '';
    this.errorMessage = [];

    let servicerTransferQuerySearchCriteria = new ServicerTransferQuerySearchCriteria();
    const transactionWrapper = new TransactionWrapper();
    servicerTransferQuerySearchCriteria = this.queryServicerTransfersForm.value;

    /** Converting date format to mm/dd/yyy */
    if (servicerTransferQuerySearchCriteria.effectiveDateFrom != null && servicerTransferQuerySearchCriteria.effectiveDateFrom !== '') {
      servicerTransferQuerySearchCriteria.effectiveDateFrom = this.utilService.convertMillisecToDate(servicerTransferQuerySearchCriteria.effectiveDateFrom);
    } else {
      servicerTransferQuerySearchCriteria.effectiveDateFrom = null;
    }

    if (servicerTransferQuerySearchCriteria.effectiveDateTo != null && servicerTransferQuerySearchCriteria.effectiveDateTo !== '') {
      servicerTransferQuerySearchCriteria.effectiveDateTo = this.utilService.convertMillisecToDate(servicerTransferQuerySearchCriteria.effectiveDateTo);
    } else {
      servicerTransferQuerySearchCriteria.effectiveDateTo = null;
    }

    if (servicerTransferQuerySearchCriteria.creationDateFrom != null && servicerTransferQuerySearchCriteria.creationDateFrom !== '') {
      servicerTransferQuerySearchCriteria.creationDateFrom = this.utilService.convertMillisecToDate(servicerTransferQuerySearchCriteria.creationDateFrom);
    } else {
      servicerTransferQuerySearchCriteria.creationDateFrom = null;
    }

    if (servicerTransferQuerySearchCriteria.creationDateTo != null && servicerTransferQuerySearchCriteria.creationDateTo !== '') {
      servicerTransferQuerySearchCriteria.creationDateTo = this.utilService.convertMillisecToDate(servicerTransferQuerySearchCriteria.creationDateTo);
    } else {
      servicerTransferQuerySearchCriteria.creationDateTo = null;
    }
    // external
    if (servicerTransferQuerySearchCriteria.servicerNumberFromUI === 'ALL') {
      if (this.serNumber.length > 1) {
        const srvlst = new Array<string>();
        srvlst.push(this.serNumber[1].value);
        for (let i = 2; i <= this.serNumber.length - 1; i++) {
          srvlst.push(this.serNumber[i].value);
        }
        servicerTransferQuerySearchCriteria.servicerNumberFrom = srvlst;
      }
    } else if (servicerTransferQuerySearchCriteria.servicerNumberFromUI != null && servicerTransferQuerySearchCriteria.servicerNumberFromUI !== '') {
      // internal
      servicerTransferQuerySearchCriteria.servicerNumberFrom =  new Array<string>();
      servicerTransferQuerySearchCriteria.servicerNumberFrom.push(servicerTransferQuerySearchCriteria.servicerNumberFromUI);
    }

    // Set the lists
    if (servicerTransferQuerySearchCriteria.servicerNumberTo !== '' && servicerTransferQuerySearchCriteria.servicerNumberTo != null) {
      servicerTransferQuerySearchCriteria.toServicerNumberList = [servicerTransferQuerySearchCriteria.servicerNumberTo];
    }

    if (servicerTransferQuerySearchCriteria.servicerNumberFrom != null && servicerTransferQuerySearchCriteria.servicerNumberFrom.length !== 0 ) {
      servicerTransferQuerySearchCriteria.fromServicerNumberList = servicerTransferQuerySearchCriteria.servicerNumberFrom;
    }

    /** validate search form data */
    this.errorMessage = this.validateForm(servicerTransferQuerySearchCriteria);

    /** When there is validation message , it stop here */
    if (this.errorMessage.length > 0) {
      return;
    }

    transactionWrapper.parameters[0] = servicerTransferQuerySearchCriteria;
    transactionWrapper.queryServiceName = Constants.GET_SERVICER_TRANSFER_LIST;

    /** Requesting data */
    this.service.getServicerTransferList(transactionWrapper).subscribe(
      (data: Array<any>) => {
        if (data == null || data.length === 0) {
          this.warningMessage = Constants.NO_DATA_MESSAGE;
          this.cdr.detectChanges();
          return;
        }
        if (data != null && data.length > 100) {
          this.warningMessage = Constants.MORE_RESULT_WARNING;
          this.cdr.detectChanges();
          return;
        }
        const servicerTransferSummaryList: ServicerTransferSummaryList = data;
        console.log(servicerTransferSummaryList);

        /** Routing to result page when there are matching records. passing list of matching keys to get results */
        this.router.navigate(['serviceTransfersResults'], {
          queryParams: {query: btoa(JSON.stringify(servicerTransferSummaryList))}
        });

      },

      error => {
        if (error.includes('504'))
        {
          this.warningMessage = Constants.QUERY_SEARCH_TAKING_LONG_WARNING;
          this.cdr.detectChanges();
          return;
        }
        else {
          this.errorService.announceError(error);
        }

      }
    );

    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  onClear(): void {
    this.queryServicerTransfersForm.reset();
  }

  /**  Validate FormModel according to business needs, return possible error to user*/
  private validateForm(servicerTransferQuerySearchCriteria: ServicerTransferQuerySearchCriteria): string[] {
    const errorMessages: string[] = [];

    /** Servicer Number From and Effective Date From are required */


    const effectiveDateFrom = servicerTransferQuerySearchCriteria.effectiveDateFrom;

    if (servicerTransferQuerySearchCriteria.servicerNumberFromUI === 'ALL' && (effectiveDateFrom === '' || effectiveDateFrom == null)) {
      errorMessages.push(this.utilService.stringReplace(Constants.REQUIRED_FIELDS_VALIDATION, 'Servicer Number Transfer From', 'Effective Date Range From'));
    }

    const servicerNumberFrom: string[] = servicerTransferQuerySearchCriteria.servicerNumberFrom;
    /** servicerNumberFrom Validation */
    if ( servicerNumberFrom != null &&  servicerNumberFrom.length > 0) {
      for (let i = 0; i < servicerNumberFrom.length; i++) {
        const servicerNumberFromDigit = /^\d+$/.test(servicerNumberFrom[i]);
        if (servicerNumberFrom[i] != null && servicerNumberFrom[i] !== ''  ) {
          if (servicerNumberFrom[i].length !== 9 || servicerNumberFromDigit !== true) {
            errorMessages.push(this.utilService.stringReplace(Constants.INVALID_FORMAT, 'Servicer Number From', '9'));
          }
        }
      }
    } else if (effectiveDateFrom === '' || effectiveDateFrom == null) {
      errorMessages.push(this.utilService.stringReplace(Constants.REQUIRED_FIELDS_VALIDATION, 'Servicer Number Transfer From', 'Effective Date Range From'));
    }


    /** servicerNumberTo Validation */
    const servicerNumberTo = servicerTransferQuerySearchCriteria.servicerNumberTo;
    const servicerNumberToDigit = /^\d+$/.test(servicerNumberTo);
    if (servicerNumberTo !== '' && servicerNumberTo != null) {
      if (servicerNumberTo.length !== 9 || servicerNumberToDigit !== true) {
        errorMessages.push(this.utilService.stringReplace(Constants.INVALID_FORMAT, 'Servicer Number To', '9'));
      }
    }

    return errorMessages;
  }
}
